var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-block"},[(_vm.$isCanEdit)?[_vm._t("default")]:[_c('permission-deny-component')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }